var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNDocDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7B809A;}\r\n\t.st1{fill:#FF3300;stroke:#FFFFFF;stroke-width:0.3;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,31.9V30h25v1.9H9.4z M9.4,25.3v-1.9h25v1.9H9.4z M9.4,18.7v-1.9h25v1.9H9.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,40.5c-0.8,0-1.5-0.3-2.1-1c-0.6-0.7-0.9-1.5-0.9-2.4V11.7c0-0.9,0.3-1.7,0.9-2.4s1.3-1.1,2.1-1.1h30 c0.8,0,1.5,0.4,2.1,1.1c0.6,0.7,0.9,1.5,0.9,2.4v25.4c0,0.9-0.3,1.7-0.9,2.4c-0.6,0.7-1.3,1-2.1,1H6.9z M6.9,37.1h30V11.7h-30V37.1z  M6.9,37.1V11.7V37.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,45.3l-1.6-1.6l8.4-8.4l-8.4-8.4l1.6-1.6l8.4,8.4l8.4-8.4l1.6,1.6L36,35.3l8.4,8.4l-1.6,1.6l-8.4-8.4 L26,45.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNDocDeleted);
export default __webpack_public_path__ + "static/media/n_doc_deleted.7f1d6a1e6dbc7af2b6db0ca51295d203.svg";
export { ForwardRef as ReactComponent };